<template>
  <page-tab :banner="banner" :breadcrumb="breadcrumb">
    <div class="contactUs">
      <div class="content" v-if="pageData.contactUs">
        <img class="address" :src="pageData.contactUs.icon" />
        <div class="contentHtml" v-html="pageData.contactUs.content"></div>
      </div>
    </div>
  </page-tab>
</template>
<script>
import PageTab from "@/components/PageTab.vue";
import banner from "@/assets/images/banner/contactUs.png";
import { getIndex } from "@/api/index";

export default {
  name: "ContactUs",
  components: {
    PageTab,
  },
  data() {
    return {
      banner,
      texts: [
        {
          text: "山东省菏泽市成武县经济开发区机电设备智造小镇 双层车间北区7号",
          icon: require("@/assets/images/contactUs/icon1.png"),
        },
        {
          text: "18502309824@qq.com",
          icon: require("@/assets/images/contactUs/icon2.png"),
        },
        {
          text: "18502309824",
          icon: require("@/assets/images/contactUs/icon3.png"),
        },
      ],
      breadcrumb: [
        { name: "首页", path: "/" },
        { name: "联系我们", path: "" },
      ],
      form: {},
      pageData: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getIndex().then((res) => {
        this.pageData = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.contactUs {
  padding: 213px 116px 58px;
  background: url(../assets/images/contactUs/back.png) center top no-repeat;
  background-size: 100%;
  .content {
    padding: 54px 28px;
    background: #fff;
    display: flex;
    .address {
      width: 40%;
    }
    .contentHtml {
      flex: 1;
      margin-left: 40px;
      line-height: 2;
    }
    img {
      max-width: 100%;
    }
  }
}
.isMobile {
  .contactUs {
    padding: 33px 36px 18px;
    .content {
      padding: 28px 16px;
      display: block;
      .address {
        width: 100%;
      }
      .contentHtml {
        margin-left: 0;
      }
    }
  }
}
</style>
